module.exports = __webpack_public_path__ + "assets/a-13-xiguan.178224c2.svg";